import React from 'react';
import { Link } from 'react-router-dom';
import { Terminal } from 'lucide-react';
import { auth } from '@/lib/api';
import SyncStatusPill from '../SyncStatusPill';

/**
 * MobileTopHeader — minimal sticky header for <640px viewports.
 *   [Logo · ApexFlow]    [Sync pill]
 *
 * Drawer toggle + primary nav lives in MobileBottomNav. Logout lives in
 * MoreDrawer to keep the top header tiny.
 */
export default function MobileTopHeader() {
  const user = auth.currentUser();
  return (
    <header
      data-testid="apex-mobile-top-header"
      style={{
        position: 'sticky', top: 0, zIndex: 200,
        background: '#0f0f0f',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 12px', minHeight: 44,
      }}>
      <Link to="/" data-testid="mobile-nav-brand"
            style={{ display: 'flex', alignItems: 'center', gap: 6,
                     textDecoration: 'none',
                     color: 'var(--text-primary)' }}>
        <Terminal style={{ color: 'var(--accent-amber)' }} size={16} />
        <span style={{ fontSize: 13, fontWeight: 700,
                       letterSpacing: '0.05em' }}>APEXFLOW</span>
      </Link>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {user && (
          <span className="label-xs"
                data-testid="mobile-nav-role"
                style={{ color: user.role === 'admin'
                  ? 'var(--accent-amber)' : 'var(--text-secondary)',
                  fontSize: 9 }}>
            {user.role?.toUpperCase()}
          </span>
        )}
        <SyncStatusPill />
      </div>
    </header>
  );
}
